<template>
	<Body class="page-checkout" />
	<BaseWebshopCheckout>
		<ClientOnly>
			<slot name="header" />

			<div class="checkout-main">
				<div class="wrapper checkout-wrapper">
					<div class="checkout-col checkout-col1">
						<slot name="wcCol2" />
					</div>

					<div class="checkout-col checkout-col2">
						<div class="checkout-cart" :class="[{'active': activeCart && mobileBreakpoint}]">
							<BaseWebshopCart v-slot="{parcels}">
								<div class="checkout-cart-intro" @click="activeCart = !activeCart">
									<BaseWebshopCart v-slot="{counter}">
										<span class="checkout-cart-icon"><span class="checkout-cart-counter">{{counter}}</span></span>
									</BaseWebshopCart>
									<template v-if="!mobileBreakpoint">
										<BaseCmsLabel code="checkout_shopping_cart_title" class="checkout-cart-title" tag="div" />
										
										<BaseUtilsAppUrls v-slot="{items: appUrls}">
											<NuxtLink :to="appUrls.webshop_shopping_cart" class="wc-btn-change">
												<BaseCmsLabel code="edit_shopping_cart" />
											</NuxtLink>
										</BaseUtilsAppUrls>
									</template>
									<template v-else>
										<div class="checkout-cart-title"> 
											<BaseCmsLabel tag="span" class="show" code="show_cart_small" />
											<BaseCmsLabel tag="span" class="hide" code="hide_cart_small" />
										</div>
										<div v-if="parcels[0]?.items?.length" class="wc-totals-container-top">
											<BaseUtilsFormatCurrency :price="parcels[0].total.total" />
										</div>
									</template>
								</div>

							
								<div class="wc-small-container">
									<div class="wc-totals" :class="{'active': showCart}">
										<div class="wc-cart-header" @click="showCart = !showCart" v-if="mobileBreakpoint">
											<BaseUtilsAppUrls v-slot="{items: appUrls}">
												<NuxtLink :to="appUrls.webshop_shopping_cart" class="wc-btn-change">
													<BaseCmsLabel code="edit" v-if="!mobileBreakpoint" />
													<BaseCmsLabel code="edit_shopping_cart" v-else />
												</NuxtLink>
											</BaseUtilsAppUrls>
										</div>
										<div class="wc-totals-inner" v-if="parcels[0]?.items?.length">
											<WebshopCartItemSmall v-for="item in parcels[0].items" mode="checkout" class="wwp-checkout" :data="item" :key="item.shopping_cart_code" />
											
											<WebshopCouponForm mode="checkout" />

											<div class="wc-total-container">
												<WebshopTotal :simple="true" mode="checkout" />
											</div>	
										</div>
									</div>
								</div>
							</BaseWebshopCart>
						</div>
					</div>
				</div>
			</div>

			<div class="checkout-footer">
				<div class="wrapper checkout-wrapper checkout-footer-wrapper">
					<BaseCmsLabel code="contact" tag="div" class="checkout-contact" />
					<BaseCmsLabel code="cards" tag="div" class="cards" />
					<BaseCmsCopyright class="copy" label="copyright" />
					
				</div>
			</div>
			</ClientOnly>
		</BaseWebshopCheckout>
</template>

<script setup>
	const {mobileBreakpoint} = inject('rwd');

	const activeCart = ref(false);
	const activeGiftCards = ref(false);
	const showCart = ref(false);
</script>

<style lang="less" scoped>
	.checkout-main{
		position: relative; 
		&:before{.pseudo(50%,100%); background: var(--lightGray); border-left: 1px solid var(--gray); top: 0; right: 0;}
		@media (max-width: @m){
			&:before{display: none;}
		}
	}
	.checkout-wrapper{
		position: relative; display: flex;
		@media (max-width: @m){flex-flow: column-reverse;}	
	}
	.checkout-col{
		display: flex; flex-flow: column; padding: 50px 100px; width: 50%;
		@media (max-width: @t){padding: 30px 30px;}
		@media (max-width: @m){width: 100%;}
	}
	.checkout-col1{
		padding-left: 0;
		@media (max-width: @m){padding: 26px 16px 28px;}	
	}
	.checkout-col2{
		padding-right: 0; padding-top: 48px;
		@media (max-width: @m){padding: 0;}	
	}

	.checkout-footer{
		position: relative; display: block; background: #fff; border-top: 1px solid var(--gray); padding: 50px 0;
		@media (max-width: @m){padding: 0;}	
	}
	.checkout-footer-wrapper{
		display: flex; align-items: center; align-items: center; justify-content: space-between;
		@media (max-width: @m){flex-flow: column; align-items: inherit; justify-content: inherit;}	
	}
	.cards{
		:deep(p){padding-bottom: 0; line-height: 0;}
		@media (max-width: @m){
			border-bottom: 1px solid var(--gray); padding: 13px 16px;
			:deep(p){display: flex;}
			:deep(a:last-child){
				display: inline; margin-left: auto; align-self: flex-end;
				img{max-height: 25px; width: auto;}	
			}
		}
	}
	.checkout-contact{
		display: flex; flex-flow: column; font-size: 14px;
		:deep(a){
			color: var(--blue); text-decoration: none; position: relative; padding-left: 26px;
			&:before{.pseudo(17px,16px); .icon-email(); font: 12px/1 var(--fonti); color: var(--blue); top: 2px; left: 0; display: flex; align-items: center; justify-content: center;}
		}	
		:deep(a[href*=tel]){
			&:before{.icon-phone-call(); font-size: 16px; top: 3px;}
		}
		@media (max-width: @m){border-bottom: 1px solid var(--gray); padding: 15px 16px; gap: 8px;}
	}
	.copy{
		display: flex; flex-flow: column; text-align: right; align-items: flex-end; font-size: 12px; line-height: 1.5; color: var(--darkGray);
		:deep(p){padding-bottom: 0;}
		@media (max-width: @m){text-align: left; padding: 16px; align-items: flex-start; font-size: 11px;}
	}
	.checkout-cart.active{
		@media (max-width: @m){
			.checkout-cart-intro{background: #fff; z-index: 1;}
			.checkout-cart-title{
				.hide{display: flex;}
				.show{display: none;}
			}
			.wc-small-container{display: flex; border-bottom: 1px solid var(--gray);}
		}
	}
	.checkout-cart-intro{
		position: relative; display: flex; margin-bottom: 13px;
		@media (max-width: @m){margin: 0; height: 56px; align-items: center; padding: 0 16px; border-bottom: 1px solid var(--gray); background-image: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(242, 245, 248, 1) 100%);}	
	}
	.wc-totals-container-top{display: block; font-size: 14px; font-weight: 700;}
	.checkout-cart-icon{
		position: relative; display: block; flex-grow: 0; flex-shrink: 0; margin-right: 22px;
		&:before{.icon-cart(); font: 26px/1 var(--fonti); color: var(--blue);}
		@media (max-width: @m){margin-right: 15px;}
	}
	.checkout-cart-counter{
		position: absolute; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; background: var(--orange); color: #fff; font-size: 12px; line-height: 1; font-weight: 700; border-radius: 50%; top: -7px; right: -16px;
		@media (max-width: @m){width: 20px; height: 20px; font-size: 11px; right: -8px;}	
	}
	.checkout-cart-title{
		display: block; font-size: 20px; line-height: 1.4; flex-grow: 1; flex-shrink: 1;
		@media (max-width: @m){
			font-size: 14px; line-height: 1; color: var(--blue);
			.show, .hide{
				display: flex; align-items: center;
				&:after{.icon-arrow-down(); font: 8px/1 var(--fonti); color: var(--blue); margin-left: 8px;}
			}
			.hide{
				display: none;
				&:after{.rotate(180deg); margin-top: -1px;}
			}	
		}	
	}
	.wc-btn-change{
		position: relative; flex-grow: 0; flex-shrink: 0; display: flex; align-items: center; font-size: 12px; line-height: 1.2; color: var(--blue); font-weight: 700; padding-left: 21px; .transition(text-decoration-color);
		&:before{.pseudo(14px,14px); .icon-edit3(); font: 14px/1 var(--fonti); color: var(--blue); left: 0; margin-top: -4px;}
		@media (min-width: @h){
			&:hover{text-decoration-color: transparent;}
		}
		@media (max-width: @m){
			width: calc(~"100% - 32px"); margin: 0 16px; padding: 14px 21px; font-size: 12px; font-weight: 700; text-decoration: underline;
			&:before{margin-top: -2px;}
		}
	}
	.wc-totals-inner{
		@media (max-width: @m){border-top: 1px solid var(--gray);}
	}
	.wc-small-container{
		position: relative; display: flex; flex-flow: column; background: #fff; border: 1px solid var(--gray); border-radius: 8px;
		@media (max-width: @m){border: none; border-radius: 0; box-shadow: 0 5px 40px rgba(0,0,0,0.08); display: none;}	
	}
	.wc-total-container{
		display: block; padding: 0 24px 20px; font-size: 14px; line-height: 1.63;
		@media (max-width: @m){padding: 0 16px 17px; }	
	}
	:deep(.checkout-steps){display: block; margin-top: 32px;}
	:deep(.checkout-btn-next-step){
		padding-left: 40px; padding-right: 40px; margin-top: 5px;
		&.loading{color: #fff!important;}
	}
	:deep(.checkout-login-form){
		margin-top: 64px;
		@media (max-width: @m){
			position: relative; display: block; margin-top: 28px; padding-top: 29px;
			&:before{.pseudo(auto,1px); background: var(--gray); top: 0; left: -16px; right: -16px;}
		}	
	}
</style>